var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "g-product-card g-product-card__hoverable g-layout__item",
      attrs: {
        "data-gtm-name": _vm.result.name,
        "data-gtm-id": _vm.result.ss_sku,
        "data-gtm-price": _vm.result.price,
        "data-gtm-category": _vm.result.gtm_category,
        "data-gtm-sku": _vm.result.ss_sku,
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "g-product-card__link",
          attrs: {
            href: _vm._f("rewriteUrl")(_vm.result.url),
            title: "View " + _vm.result.name,
          },
          on: {
            mousedown: function ($event) {
              return _vm.intelliSuggest($event, _vm.result)
            },
          },
        },
        [
          _c("div", { staticClass: "g-product-card__image" }, [
            _vm.result.flag && _vm.result.flag.length
              ? _c("span", { staticClass: "g-product-flag g-flag-style-1" }, [
                  _vm._v(_vm._s(_vm.result.flag)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "g-product-card__image-source",
              attrs: {
                src: _vm.getProductImage(_vm.result),
                alt: _vm.result.name,
                height: "308",
                width: "216",
                loading: "lazy",
              },
              on: {
                error: _vm.setErrorImage,
                mouseenter: function ($event) {
                  return _vm.productImageSwap(_vm.result, $event)
                },
                mouseleave: function ($event) {
                  return _vm.productImageSwap(_vm.result, $event)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "g-product-card__footer" }, [
            _c("div", {
              staticClass: "g-product-card__name",
              domProps: { innerHTML: _vm._s(_vm.result.name) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "g-product-card__information" }, [
              _c("div", { staticClass: "g-product-card__pricing" }, [
                _vm.result.original_price > _vm.result.price
                  ? _c("s", { staticClass: "g-product-card__base-price" }, [
                      _c("span", { staticClass: "u-hide-visually" }, [
                        _vm._v("Original Price: "),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm._f("toCurrency")(_vm.result.original_price)
                          ) +
                          "\n\t\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "g-product-card__price" }, [
                  _vm.result.original_price > _vm.result.price
                    ? _c("span", { staticClass: "u-hide-visually" }, [
                        _vm._v("Sale Price: "),
                      ])
                    : _c("span", { staticClass: "u-hide-visually" }, [
                        _vm._v("Price: "),
                      ]),
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm._f("toCurrency")(_vm.result.price)) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "g-product-card__shipping" }, [
              _vm.result.instore_only === "yes"
                ? _c("span", { staticClass: "g-flag-shipping" }, [
                    _c("span", {
                      staticClass:
                        "g-product-card__shipping-icon u-icon-pickup",
                    }),
                    _vm._v(" In Store Only\n\t\t\t\t"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.result.pickup_only === "yes"
                ? _c("span", { staticClass: "g-flag-shipping" }, [
                    _c("span", {
                      staticClass:
                        "g-product-card__shipping-icon u-icon-pickup",
                    }),
                    _vm._v(" Pick Up Only\n\t\t\t\t"),
                  ])
                : _vm.result.currently_unavailable === "yes"
                ? _c("span", { staticClass: "g-flag-shipping" }, [
                    _c("span", {
                      staticClass: "g-product-card__shipping-icon u-icon-cross",
                    }),
                    _vm._v(" Unavailable\n\t\t\t\t"),
                  ])
                : _c("span", [_vm._v(" ")]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }